import { User } from '@/features/admin/types/user';

import { Client } from './models/client';

export const isUserPrimaryAdmin = (user: User, client: Client) => {
  if (!user || !client) return false;

  return user.id === client.primaryUser?.id;
};
